"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1223],{

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 72998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./containers/Support/SearchForm.js
var SearchForm = __webpack_require__(32463);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
;// CONCATENATED MODULE: ./containers/Support/Sidebar.js






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, settings = _publicRuntimeConfig.settings, _content = _publicRuntimeConfig.content, _supportMenuLinks = _content.supportMenuLinks, stores = _supportMenuLinks.stores, contact = _supportMenuLinks.contact;
var isBricoStore = settings.websiteName === "bricostore";
var Sidebar = /*#__PURE__*/ function(PureComponent1) {
    "use strict";
    _inherits(Sidebar, PureComponent1);
    var _super = _createSuper(Sidebar);
    function Sidebar() {
        _classCallCheck(this, Sidebar);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "state", {
            mergedItems: _toConsumableArray(_this.props.items).concat([
                stores,
                contact
            ]),
            activeIndex: [],
            activeSlug: ""
        });
        _defineProperty(_assertThisInitialized(_this), "setActiveIndex", function(index) {
            var activeIndex = _this.state.activeIndex;
            _this.setState({
                activeIndex: activeIndex.includes(index) ? activeIndex.filter(function(i) {
                    return i !== index;
                }) : _toConsumableArray(activeIndex).concat([
                    index
                ])
            });
        });
        return _this;
    }
    _createClass(Sidebar, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _state = this.state, mergedItems = _state.mergedItems, activeIndex = _state.activeIndex, activeSlug = _state.activeSlug;
                var activeSlugNoHost = activeSlug.replace(settings.baseUrl, "");
                var back = this.props.back;
                if (!mergedItems || !mergedItems.length) {
                    return null;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: back && back.slug ? "".concat(settings.baseUrl).concat(back.slug) : "".concat(settings.baseUrl, "/suport-clienti/"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "block lg:hidden text-sm text-red-brand leading-18.2 -tracking-0.29",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "inline-block rotate-90 mr-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                                    }),
                                    back && back.title ? back.title : "Inapoi la meniu"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden lg:block text-left border rounded-tr-xl rounded-bl-xl border-gray-1100 bg-white",
                            children: mergedItems.map(function(item, i) {
                                var _this1 = _this;
                                var articles = item.children, links = item.links, isActive = activeIndex.includes(i);
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: i !== 0 ? "border-t border-gray-1100" : "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "\n                    flex items-center cursor-pointer px-4 py-2 border-l-4\n                    ".concat(isActive ? isBricoStore ? "border-red-brand" : "border-primary" : "border-transparent", "\n                  "),
                                            onClick: function() {
                                                return _this1.setActiveIndex(i);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "grow -tracking-0.39 pr-2 text-sm sm:hover:text-red-brand ".concat(isActive ? "text-newGray-mildDark" : ""),
                                                    children: item.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "duration-75 ".concat(isActive ? "rotate-180" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                                        width: "9px",
                                                        height: "9px"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "m-0 px-10 py-15px border-gray-1100 border-t font-normal text-15px ".concat(isActive ? "" : "hidden"),
                                            children: [
                                                articles && articles.map(function(article) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RenderMenuSubItem, {
                                                        item: article,
                                                        isActive: activeSlugNoHost === article.slug,
                                                        link: "".concat(settings.baseUrl, "/suport-clienti/").concat(article.slug, "/")
                                                    }, article.slug);
                                                }),
                                                links && links.map(function(link) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RenderMenuSubItem, {
                                                        item: link,
                                                        isActive: activeSlugNoHost === link.slug,
                                                        link: link.slug.startsWith("http") ? link.slug : "".concat(settings.baseUrl).concat(link.slug)
                                                    }, link.slug);
                                                })
                                            ]
                                        })
                                    ]
                                }, item.name));
                            })
                        })
                    ]
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var currentUrl = nextProps.currentUrl, nextActiveSlug = getActiveSlugFromUrl(currentUrl), mergedItems = prevState.mergedItems, activeSlug = prevState.activeSlug;
                var activeIndex = prevState.activeIndex;
                if (nextActiveSlug !== activeSlug) {
                    for(var i = 0; i < mergedItems.length; i++){
                        var _i = mergedItems[i], articles = _i.children, links = _i.links, itemChild = articles || links;
                        var newActiveIndex = null;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = itemChild[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var child = _step.value;
                                if (nextActiveSlug.includes(child.slug)) {
                                    newActiveIndex = [
                                        i
                                    ];
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (newActiveIndex) {
                            activeIndex = newActiveIndex;
                            break;
                        }
                    }
                }
                return _objectSpread({}, prevState, {
                    activeIndex: activeIndex,
                    activeSlug: nextActiveSlug
                });
            }
        }
    ]);
    return Sidebar;
}(react.PureComponent);
var getActiveSlugFromUrl = function(currentUrl) {
    var query = currentUrl.query, urlAsPath = currentUrl.urlAsPath, asPath = currentUrl.asPath;
    return query.category || urlAsPath || asPath;
};
var RenderMenuSubItem = function(param) {
    var item = param.item, link = param.link, isActive = param.isActive;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
        style: {
            paddingTop: "4px",
            paddingBottom: "4px"
        },
        children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "inline-block text-newGray-mildDark leading-24 -tracking-0.29",
            children: item.name
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: link,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "inline-block text-black hover:text-red-brand leading-24 -tracking-0.29 mb",
                children: item.name
            })
        })
    }, item.slug);
};
/* harmony default export */ var Support_Sidebar = ((0,es/* connect */.$j)(function(state) {
    return {
        currentUrl: state.navigation.currentUrl
    };
})(Sidebar));

;// CONCATENATED MODULE: ./containers/Support/Layout.js




var SupportLayout = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flow-root",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm/* default */.Z, {
                    hasTitle: props.hasTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:w-1/4 is-hidden-in-mobile-app",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:mx-0 pt-4 lg:pt-12 lg:py-6",
                                id: "navigatie-suport",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_Sidebar, {
                                    items: props.categories,
                                    back: props.back
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:w-3/4 lg:pl-12",
                            children: props.children
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Layout = (SupportLayout);


/***/ }),

/***/ 32463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66688);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58833);






var handleFormSubmit = function(param) {
    var search = param.search;
    // merge cu gateway-ul de live. Pe stage apar erori CORS
    next_router__WEBPACK_IMPORTED_MODULE_3__["default"].push("/suport-clienti/cauta/?qs=".concat(search));
};
var SupportSearchForm = function(param1) {
    var router = param1.router, _label = param1.label, label = _label === void 0 ? null : _label, _hasTitle = param1.hasTitle, hasTitle = _hasTitle === void 0 ? true : _hasTitle;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "\n      is-hidden-in-mobile-app-contact-page\n      py-4\n      lg:py-0\n      ".concat(hasTitle == true && label ? "lg:mt-12" : "mt-4 lg:mt-0", "\n    "),
            children: [
                hasTitle && label,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:w-524px mx-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                        onSubmit: handleFormSubmit,
                        initialValues: {
                            search: router.query.qs || ""
                        },
                        render: function(param) {
                            var handleSubmit = param.handleSubmit, submitting = param.submitting;
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                onSubmit: handleSubmit,
                                className: "w-full mt-4",
                                autoComplete: "off",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                            name: "search",
                                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                            placeholder: "Cauta in articolele de suport",
                                            minLength: "3",
                                            maxLength: "50",
                                            required: true,
                                            className: "\n                        SearchInputComponent\n                        w-full mb-0 text-black border border-gray-light p-3 pl-5\n                        rounded-bl-lg\n                        rounded-tr-lg bg-white\n                        focus:border-black outline-none\n                      "
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "submit",
                                            title: "Cauta",
                                            disabled: submitting,
                                            className: "v-align-middle-abs right-3 pl-3 ie-top",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                width: "17",
                                                height: "17",
                                                viewBox: "0 0 17 17",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M11.4834 13.0863L12.8167 11.7529L15.8499 14.7861C16.2181 15.1543 16.2181 15.7513 15.8499 16.1195C15.4818 16.4877 14.8848 16.4877 14.5166 16.1195L11.4834 13.0863Z",
                                                        fill: "#ADADAD"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                        cx: "7.5",
                                                        cy: "7.5",
                                                        r: "6.75",
                                                        stroke: "#ADADAD",
                                                        strokeWidth: "1.5"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }));
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_3__.withRouter)(SupportSearchForm));


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 3697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eU": function() { return /* binding */ getSupportCategories; },
/* harmony export */   "fk": function() { return /* binding */ getSupportCategoryArticles; },
/* harmony export */   "i_": function() { return /* binding */ getSupportSearchArticles; },
/* harmony export */   "ck": function() { return /* binding */ getSupportIndex; }
/* harmony export */ });
/* harmony import */ var _store_support_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76970);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);



var getSupportCategories = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORIES */ .mD,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORIES_SUCCESS */ .$Z,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORIES_FAILURE */ .mZ
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportCategoriesApi */ .ePT,
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};
var getSupportCategoryArticles = function(category) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORY_ARTICLES */ .o4,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORY_ARTICLES_SUCCESS */ .t_,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORY_ARTICLES_FAILURE */ .sA
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportCategoryArticlesApi */ .$qG,
            apiArgs: [
                encodeURIComponent(category)
            ],
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};
var getSupportSearchArticles = function(searchParams) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_SEARCH_ARTICLES */ .t7,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_SEARCH_ARTICLES_SUCCESS */ .P9,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_SEARCH_ARTICLES_FAILURE */ .bz
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportSearchArticlesApi */ .amr,
            apiArgs: [
                searchParams
            ],
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};
var getSupportIndex = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_INDEX */ .c9,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_INDEX_SUCCESS */ .kA,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_INDEX_FAILURE */ .Ew
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportIndexApi */ .eBQ,
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};


/***/ })

}]);